import {SerializedObject, SerializedResource} from "../shared/eventer-pod.ts";

export class ResourceWrapper {

    constructor(private readonly resource: SerializedResource) {}

    get subject(): string {
        return this.resource.subject
    }

    get predicates(): SerializedResource["predicates"] {
        return this.resource.predicates
    }

    getFirstString(pred: string, graphs?: string[]): undefined | string {
        let all = this.getAllStrings(pred, graphs)
        if (!all) return undefined
        if (all.length == 0) {
            return undefined
        }
        return all[0]
    }

    getAllStrings(pred: string, graphs?: string[]): undefined | string[] {
        const objects = this.resource.predicates[pred]
        if (!objects) return undefined
        return (graphs ? objects.filter(o => graphs.includes(o.graph)) : objects)
            // .filter(o => !o.datatype || o.datatype === 'http://www.w3.org/2001/XMLSchema#string')
            .map(o => o.object)
    }

    getMinDate(predicate: string, graphs?: string[]): Date | undefined {
        const dateStrings = this.getAllStrings(predicate, graphs)
        if (!dateStrings || dateStrings.length === 0) {
            return undefined
        }

        let min: Date | undefined = undefined
        for (const str of dateStrings) {
            const date = new Date(str)
            if (!isNaN(date.getTime())) {
                if (!min || date < min) {
                    min = date
                }
            }
        }

        return min
    }

    equals(other: ResourceWrapper): boolean {
        if (this.subject !== other.subject) {
            return false
        }

        const aPredicates = this.predicates
        const bPredicates = other.predicates

        const aKeys = Object.keys(aPredicates)
        const bKeys = Object.keys(bPredicates)

        if (aKeys.length !== bKeys.length) {
            return false
        }

        for (const aKey of aKeys) {
            const aVals = aPredicates[aKey]
            const bVals = bPredicates[aKey]

            if (!bVals || aVals.length !== bVals.length) {
                return false
            }

            for (let i = 0; i < aVals.length; i++) {
                if (!serializedObjectEquals(aVals[i], bVals[i])) {
                    return false
                }
            }
        }

        return true
    }
}

export function serializedObjectEquals(a: SerializedObject, b: SerializedObject): boolean {
    return (
        a.object === b.object &&
        a.graph === b.graph &&
        a.language === b.language &&
        a.datatype === b.datatype
    )
}
